module.exports = __webpack_public_path__ + "19b1692e279a4e18e1b115648174c0e9.fbx";